import { useBooleanState } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { BareItem } from '@calendly/ui/components/menu';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { isEnterKey, isSpaceKey } from 'services/keycodes';
const switchItemCss = "s1ul70yh";
const SwitchItem = forwardRef((props, ref) => {
  const as = 'label';
  return <BareItem ref={ref} {...props} as={as} className={classNames(switchItemCss, props.className)} />;
});
const switchCss = "s17rlgos";
const Switch = forwardRef((props, ref) => <SwitchInput ref={ref} {...props} className={classNames(switchCss, props.className)} />);
export const ActivationToggleItem = ({
  active,
  activate,
  deactivate,
  updateLabel,
  disabled = false,
  ...props
}) => {
  const [isSwitchDisabled, disableSwitch, enableSwitch] = useBooleanState(disabled);
  const toggleActivation = () => {
    disableSwitch();
    if (active) {
      deactivate().finally(enableSwitch);
    } else {
      activate().finally(enableSwitch);
    }
  };
  const onKeyDown = event => {
    if (!(isEnterKey(event) || isSpaceKey(event))) {
      return;
    }
    toggleActivation();
  };
  let label = I18n.t('publisher.event_types.context.on_off');
  if (updateLabel) {
    if (active) {
      label = I18n.t('publisher.action.on');
    } else {
      label = I18n.t('publisher.action.off');
    }
  }
  return <SwitchItem {...props}>
      {label}
      <Switch checked={active} disabled={isSwitchDisabled} onChange={toggleActivation} onKeyDown={onKeyDown} />
    </SwitchItem>;
};

require("./activation_toggle_item.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./activation_toggle_item.js");